//header fixed
$(".wd-product-page-header-handle").click(function () {
  if ($(this).hasClass("wd-product-page-header-handle-active")) {
    $(this).removeClass("wd-product-page-header-handle-active");
    $(this).addClass("wd-product-page-header-handle-active2");
    $(this).siblings(".wd-product-page-header-handle-menu").slideUp();
  } else {
    $(this).removeClass("wd-product-page-header-handle-active2");
    $(this).addClass("wd-product-page-header-handle-active");
    $(this).siblings(".wd-product-page-header-handle-menu").slideDown();
  }
});
$(document).scroll(function () {
  var scroH = $(document).scrollTop();
  var header = $(".wd-product-page-content").offset().top;
  if (scroH >= header) {
    $(".wd-product-page-header").css("position", "fixed");
    $(".wd-product-page-header").css("z-index", "3");
  } else {
    $(".wd-product-page-header").css("position", "absolute");
    $(".wd-product-page-header").css("z-index", "1");
  }
});
//banner video show
$(".wd-product-page-banner-video").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "https://www.youtube.com/embed/ktjOcAkAqQ4");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show")
    .fadeIn(200);
  $(this).parents("html").css("overflow", "hidden");
  $(this).parents(".wd-product-page-content").css("z-index", "9");
});
$(".wd-product-page-banner-video-show-btn").click(function () {
  $(this).parents(".wd-product-page-banner-video-show").fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "");
  $(this).parents("html").css("overflow", "auto");
  $(this).parents(".wd-product-page-content").css("z-index", "1");
});
$(".wd-product-page-banner-video-show").click(function () {
  $(this).fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "");
  $(this).parents("html").css("overflow", "auto");
  $(this).parents(".wd-product-page-content").css("z-index", "1");
});
//video show
// $('.wd-product-page-video video').trigger('pause');
// $(document).scroll(function () {

//   var scroH = $(document).scrollTop();
//   var header = $(".wd-product-page-video").offset().top;
//   // var window_width = $(window).width();
//   // if(window_width > 1220){
//     if(scroH > header - 100){
//       $('.wd-product-page-video video')[0].play();
//     }
//   // }

// })

// swiper scene start
var wd_product_swiper = new Swiper(".wd-product-background-swiper", {
  loop: true,
  navigation: {
    nextEl: ".wd-product-swiper-button-next",
    prevEl: ".wd-product-swiper-button-prev",
  },
  pagination: {
    clickable: true,
  },
  on: {
    slideChange: function () {
      if (this.activeIndex == 1) {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(0)
          .addClass("overview-item-wide-swiper-menu-item-active");
      } else if (this.activeIndex == 2) {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(1)
          .addClass("overview-item-wide-swiper-menu-item-active");
      } else if (this.activeIndex == 3) {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(2)
          .addClass("overview-item-wide-swiper-menu-item-active");
      } else if (this.activeIndex == 4) {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(3)
          .addClass("overview-item-wide-swiper-menu-item-active");
      } else if (this.activeIndex == 5) {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(4)
          .addClass("overview-item-wide-swiper-menu-item-active");
      } else if (this.activeIndex == 0) {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(4)
          .addClass("overview-item-wide-swiper-menu-item-active");
      } else {
        $(".overview-item-wide-swiper-menu-item").removeClass(
          "overview-item-wide-swiper-menu-item-active"
        );
        $(".overview-item-wide-swiper-menu-item")
          .eq(0)
          .addClass("overview-item-wide-swiper-menu-item-active");
      }
    },
  },
});
$(".overview-item-wide-swiper-menu-item").click(function () {
  wd_product_swiper.slideTo($(this).index() + 1);
  $(this).siblings().removeClass("overview-item-wide-swiper-menu-item-active");
  $(this).addClass("overview-item-wide-swiper-menu-item-active");
});

// media start
var swiper = new Swiper(".wd-v2-index-media-swiper", {
  slidesPerView: "auto",
  spaceBetween: 0,
  MouseEvent: true,
  navigation: {
    nextEl: ".wd-v2-index-media-swiper-next",
    prevEl: ".wd-v2-index-media-swiper-prev",
  },
});

$(
  ".wd-v2-index-media-all .wd-v2-index-media-swiper .swiper-wrapper .wd-v2-index-media-swiper-slide"
).hover(function () {
  $(this)
    .addClass("wd-v2-index-media-active")
    .siblings(".wd-v2-index-media-swiper-slide")
    .removeClass("wd-v2-index-media-active");
  var i = $(this).index();
  $(this)
    .parents()
    .siblings(".wd-v2-index-media-content")
    .find("div")
    .eq(i)
    .show()
    .siblings("div")
    .hide();
});

//NSF hover btn
$(".wd-product-page-hover-btn").mouseenter(function () {
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation",
    "animation-top-enter 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation",
    "animation-bottom-enter 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation-fill-mode",
    "forwards"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation-fill-mode",
    "forwards"
  );
});
$(".wd-product-page-hover-btn").mouseleave(function () {
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation",
    "animation-top-leave 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation",
    "animation-bottom-leave 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation-fill-mode",
    "forwards"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation-fill-mode",
    "forwards"
  );
});

//hover animation
$(".wd-product-page-more_pure-animation2").mouseenter(function () {
  $(this)
    .find(".wd-product-page-more_pure-animation2-content-circle-box")
    .css("animation", "box-animation 0.8s");
  $(this)
    .find(".wd-product-page-more_pure-animation2-content-circle-box")
    .css("animation-fill-mode", "forwards");
});

//click choose card
$(".wd-product-page-header-title").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-spe").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeIn();
  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-spe").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-faq").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-faq").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

//faq click show
$(".wd-product-page-faq-content-q").click(function () {
  if (
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .css("display") == "none"
  ) {
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideUp();
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-q-minus")
      .css("display", "none");
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-q-add")
      .css("display", "block");

    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideDown();
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .css("display", "flex");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .css("display", "none");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .eq(1)
      .css("display", "block");
  } else {
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideUp();
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .css("display", "none");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .eq(0)
      .css("display", "block");
  }
});

var more_pure_swiper = new Swiper(
  ".wd-product-page-more_pure-animation-mobile-swiper",
  {
    pagination: {
      el: ".wd-product-page-more_pure-animation-progress-line",
      type: "progressbar",
    },
    on: {
      progress: function (swiper, progress) {
        if (progress == 0.5) {
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation",
            "box-animation 0.8s"
          );
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation-fill-mode",
            "forwards"
          );
        } else {
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation",
            "none"
          );
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation-fill-mode",
            "forwards"
          );
        }
      },
    },
  }
);
var more_quickly_swiper = new Swiper(
  ".wd-product-page-more_quickly-animation-mobile-swiper",
  {
    pagination: {
      el: ".wd-product-page-more_quickly-animation-progress-line",
      type: "progressbar",
    },
  }
);

var more_economical_swiper = new Swiper(
  ".wd-product-page-more_economical-animation-swiper",
  {
    pagination: {
      el: ".wd-product-page-more_pure-more_economical-progress-line",
      type: "progressbar",
    },
  }
);

var family_swiper = new Swiper(
  ".wd-product-page-family-animation-mobile-swiper",
  {
    pagination: {
      el: ".wd-product-page-family-animation-progress-line",
      type: "progressbar",
    },
  }
);

// banner GSAP
gsap.registerPlugin(ScrollTrigger);
// ScrollTrigger.normalizeScroll(true);
ScrollTrigger.config({ ignoreMobileResize: true });

var window_width = $(window).width();

// featured animation
$(document).scroll(function () {
  var H_scroll = $(document).scrollTop();
  var window_height = $(window).height();
});

var sections_more_pure = gsap.utils.toArray(
  ".wd-product-page-more_pure-animation-item"
);
var sections_more_quickly = gsap.utils.toArray(
  ".wd-product-page-more_quickly-animation-item"
);
var sections_more_economical = gsap.utils.toArray(
  ".wd-product-page-more_economical-animation-item"
);
var sections_more_secure = gsap.utils.toArray(
  ".wd-product-page-family-animation-item"
);

var tl_more_pure_animation;
var tl_more_quickly_animation;
var tl_more_economical_animation;
var tl_family_animation;
var H_scroll;
var click_H_scroll;

$(document).scroll(function () {
  H_scroll = $(document).scrollTop();
});

// more pure
$(".wd-product-page-more_pure-btn").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-more_pure-animation-content")
    .css({ left: "0", "z-index": "99", display: "block"});
  if (window_width > 1220) {
    $("body").css("height", "300vh");
  } else {
    $("body").css("height", "100vh");
    more_pure_swiper.slideTo(0,0,false)
  }

  var more_pure_scroll_width = 1.88 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_more_pure_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-more_pure-animation",
        // pin: true,
        start: "top top",
        end: innerHeight * 2,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-more_pure-animation-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_pure, {
      x: "-" + more_pure_scroll_width,
    });
});
$(".wd-product-page-more_pure-animation-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-more_pure-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-more_pure-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });
  $("body").css("height", "auto");
  tl_more_pure_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// more quickly
$(".wd-product-page-more_quickly-btn").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-more_quickly-animation-content")
    .css({ display: "block", left: "0", "z-index": "99" });
  if (window_width > 1220) {
    $("body").css("height", "200vh");
  } else {
    $("body").css("height", "100vh");
    more_quickly_swiper.slideTo(0,0,false)
  }

  var more_quickly_scroll_width = 0.97 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_more_quickly_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-more_quickly-animation",
        // pin: true,
        start: "top top",
        end: innerHeight,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-more_quickly-animation-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_quickly, {
      x: "-" + more_quickly_scroll_width,
    });
});
$(".wd-product-page-more_quickly-animation-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-more_quickly-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-more_quickly-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });
  $("body").css("height", "auto");
  tl_more_quickly_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// more economical
$(".wd-product-page-more_economical-content-btn").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-more_economical-animation-content")
    .css({ display: "block", left: "0", "z-index": "99" });
  if (window_width > 1220) {
    $("body").css("height", "200vh");
  } else {
    $("body").css("height", "100vh");
    more_economical_swiper.slideTo(0,0,false)

  }
  var more_economical_scroll_width = 0.66 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_more_economical_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-more_economical-animation",
        start: "top top",
        // y:()=>{
        //   innerHeight
        // },
        end: innerHeight,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-more_economical-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_economical, {
      x: "-" + more_economical_scroll_width,
      ease: "none",
    });
});
$(".wd-product-page-more_economical-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-more_economical-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-more_economical-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });

  // tl_more_economical_animation.kill();
  $("body").css("height", "auto");
  tl_more_economical_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// more secure //family
$(".wd-product-page-family-btn-content").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-family-animation-content")
    .css({ display: "block", left: "0", "z-index": "99" });
  if (window_width > 1220) {
    $("body").css("height", "300vh");
  } else {
    $("body").css("height", "100vh");
    family_swiper.slideTo(0,0,false)

  }
  var family_scroll_width = 2.125 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_family_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-family-animation",
        // pin: true,
        start: "top top",
        // y:()=>{
        //   innerHeight
        // },
        end: innerHeight * 2,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-family-animation-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_secure, {
      x: "-" + family_scroll_width,
      ease: "none",
    });
});
$(".wd-product-page-family-animation-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-family-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-family-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });

  // tl_family_animation.kill();
  $("body").css("height", "auto");
  tl_family_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// movie start
$(document).ready(function () {
  $(".wd-product-page-more_pure-content").mouseenter(
    function () {
      $(this).find("video").get(0).play();
    }
  );
  $(".wd-product-page-more_quickly-content").mouseenter(
    function () {
      $(this).find("video").get(0).play();
    }
  );
  if (window_width >= 768) {
    $(".wd-product-page-more_convenient").mouseenter(
      function () {
        $(this).find("video").get(0).play();
      }
    );
  } else {
    $(".wd-product-page-more_convenient").mouseenter(
      function () {
        $(this).find("video").eq(1).get(0).play();
      }
    );
  }

  $(".wd-product-page-filter_replacement").mouseenter(
    function () {
      $(this).find("video").get(0).play();
    }
  );
});

var swiper = new Swiper(".blocks-video-items-video", {
  slidesPerView: "auto",
 
  breakpoints: {
    1220: {
      centeredSlides: false,
      spaceBetween: 44,
    },
    768: {
      centeredSlides: false,
      spaceBetween: 16,
    },
    0: {
      centeredSlides: true,
      spaceBetween: 12,
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".blocks-video-title-btn-next",
    prevEl: ".blocks-video-title-btn-prev",
  },
});

var swiper_reviews = new Swiper(".wd-product-page-reviews-swiper", {
  autoplay: true,
  loop: true,
  effect: "fade",
  navigation: {
    nextEl: ".wd-product-page-reviews-swiper-button-next",
    prevEl: ".wd-product-page-reviews-swiper-button-prev",
  },
});